import React from "react";
// auras
import move from '../../images/new/auras/move.png'
import love from '../../images/new/auras/love.png'
import intention from '../../images/new/auras/intention.png'
import elevate from '../../images/new/auras/elevate.png'
import awaken from '../../images/new/auras/awaken.png'
import wisdom from '../../images/new/auras/wisdom.png'
import peace from '../../images/new/auras/peace.png'
import phone from '../../images/phone.png'
import nourish from '../../images/new/auras/nourish.png'

import { useEffect } from "react";
// importing aos
import AOS from "aos";
import "aos/dist/aos.css";
function AurasSlider() {
  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);
  return (
    <section id="collection-pets">
      <div className="wrapper">

        {/* Auras */}
        <div className="auras">
          <h2>Auras</h2>
          <p>Each Hippie is equipped with an aura. The color of each aura represents a category of The Heal App. The corresponding Aura will unlock that section of The Heal App.</p>
          <div className="scroll-pets loop-slider">
            <div className="inner reverseDirection">
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={nourish} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>Nourish</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={move} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>move</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={love} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>love</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={intention} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>intention</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={elevate} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>Mind</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={awaken} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>awaken</p>
                </div>
              </div>
              <div className="space pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={wisdom} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>wisdom</p>
                </div>
              </div>
              <div className="pets-nft">
                <div className="pet-img">
                  <span>
                    <img src={peace} alt="" />
                  </span>
                </div>
                <div className="title">
                  <p>peace</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default AurasSlider;

